import React, { useState } from "react";
import styled from "styled-components";
import { LabelText, TitleText } from "../../ui/Text";
import { get } from "../../utils/get";
import { TimelineTaskInfoSubject } from "../../subjects/TimelineTaskInfoSubject";
import { StatusIcon } from "../../assets/svg/StatusIcon";
import { CompleteIcon } from "../../assets/svg/CompleteIcon";
import { Clock } from "../../assets/svg/Clock";
import moment from "moment";

//TODO mark task as complete

export const TimelineItem = ({
  data,
  markAsComplete,
  user,
  active,
  setActive,
}) => {
  function days_between() {
    let a = moment(moment(get(data, "due_date")).format("DD-MMM-YYYY"));
    let b = moment(moment().format("DD-MMM-YYYY"));
    const days = a.diff(b, "days");
    return days > 0
      ? { days: `Due in ${days} days`, color: "#FCB444", background: "#FFF2DF" }
      : days === 0
      ? { days: "Due Today", color: "#01A8CE", background: "#EBEFFF" }
      : {
          days: `${days * -1} Days overdue`,
          color: "#FF6666",
          background: "#FFE4E4",
        }; // 1
  }

  const status = get(data, "owners").filter(
    (owner) => owner.owner_id === get(user, "id")
  );

  return (
    <TimelineItemComponent>
      <TitleText
        style={{
          padding: "1em",
          borderLeft: active === get(data, "id") ? "5px solid #01A8CE" : "",
        }}
      >
        {moment(get(data, "due_date")).format("DD MMM")}
        <br />
        <TitleText>{get(data, "task_times[0].start_time")}</TitleText>
      </TitleText>
      <VerticalLine />
      <TaskComponentContainer
        onClick={() => {
          setActive(get(data, "id"));
          TimelineTaskInfoSubject.next(data);
        }}
      >
        <TaskComponentRow1
          backgroundColor={
            get(status, "[0]status", "") === "complete" ||
            get(data, "status", "") === "complete"
              ? "#D0F5EB"
              : days_between().background
          }
          color={
            get(status, "[0]status", "") === "complete"
              ? "#13C997"
              : days_between().color
          }
        >
          <LabelText>
            <Clock /> {moment(get(data, "due_date", "")).format(" HH:mm a")}
          </LabelText>
          <div />
          <TitleText>
            {status.length
              ? get(status, "[0]status", "") === "active"
                ? days_between().days
                : get(status, "[0]status", "")
              : get(data, "status", "") === "active"
              ? days_between().days
              : get(status, "[0]status", "")}
          </TitleText>
        </TaskComponentRow1>

        <TitleText style={{ marginBottom: "0.5em" }}>
          {get(data, "name", "")}{" "}
          <StatusIcon
            color={
              get(status, "[0]status", "") === "active" ? "#FF6666" : "#13C997"
            }
            style={{ marginLeft: 10 }}
          />
        </TitleText>
        <TaskComponentRow2>
          <LabelText>{get(data, "initiative.name", "")}</LabelText>
          <div>
            <ImagesContainer>
              {get(data, "owners", []).map((owner) => (
                <ImageItem
                  height={25}
                  width={25}
                  src={
                    owner?.avatar_url || require("../../assets/images/user.png")
                  }
                  alt="owner"
                />
              ))}
            </ImagesContainer>
            {get(status, "[0]status") === "active" && (
              <TitleText
                onClick={() => {
                  markAsComplete(get(data, "id"));
                }}
              >
                Mark as completed <CompleteIcon style={{ marginLeft: 5 }} />
              </TitleText>
            )}
          </div>
        </TaskComponentRow2>
      </TaskComponentContainer>
    </TimelineItemComponent>
  );
};

const TimelineItemComponent = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 12fr;
  align-items: center;
  height: 10em;
  justify-items: center;
  margin-bottom: 2em;
`;

const VerticalLine = styled.div`
  height: 120%;
  border-right: 2px solid #ebeeff;
  justify-self: start;
`;

const TaskComponentContainer = styled.div`
  height: 7em;
  width: 100%;
  background-color: #f5f6fb;
  border-radius: 15px;
  padding: 1em;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  cursor: pointer;
`;

const ImagesContainer = styled.div`
  align-items: center;
  justify-content: center;
  margin-top: 1em;
`;
const ImageItem = styled.img`
  /* margin-left: -10px; */
  border: 0.2em solid #fff;
  border-radius: 1em;
`;
const TaskComponentRow1 = styled.div<{
  backgroundColor: string;
  color: string;
}>`
  display: grid;
  grid-template-columns: 2fr 8fr 3fr;
  align-items: center;
  ${TitleText} {
    color: ${(props) => props.color};
    background-color: ${(props) => props.backgroundColor};
    padding: 0.2em 0;
    text-align: center;
    border-radius: 5px;
    font-size: 12px;
    text-transform: capitalize;
  }
  ${LabelText} {
    font-size: 12px;
    align-items: center;
  }
`;

const TaskComponentRow2 = styled.div`
  display: flex;
  grid-template-columns: 3fr 2fr;
  /* align-items: center; */
  padding: 0 0 1em 0;
  flex-direction: column;
  div {
    display: flex;
    justify-content: space-between;
    ${TitleText} {
      display: flex;
      justify-self: right;
      font-size: 12px;
    }
  }

  ${LabelText} {
    font-size: 12px;
  }
`;
